import Axios from "axios";

const BASEURL = `${process.env.REACT_APP_SERVER_URL}announcement`;

export const getAllByRegion = (obj) =>
  Axios.post(`${BASEURL}/getAllByRegion`, obj);

export const getAnnouncementsCountByRegion = (obj) =>
  Axios.post(`${BASEURL}/getAnnouncementsCountByRegion`, obj);
